// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"e344d1f8","751":"e344d1f8"}[chunkId] + ".chunk.css";
};